module.exports = __webpack_public_path__ + "img/hydrahost.8fbaa4b3.png";